import * as React from 'react';
import { IconVideo16 } from '@cian/ui-kit';
import { IVillageVideo } from '../../../types/village';

export const useLabels = (videos: IVillageVideo[] | null | undefined) => {
  return React.useMemo(() => {
    if (!videos?.length) {
      return [];
    }

    return [{ icon: <IconVideo16 color={'white_100'} />, title: 'Посёлок с видео' }];
  }, [videos]);
};
